import { AddApproversV2Meta, AddApproversV2Payload } from 'types/store/AddApproversV2';
import { createAsyncReducer } from 'utils/Redux';

import { addApproversV2Actions } from '../actions';

export default createAsyncReducer<AddApproversV2Meta, AddApproversV2Payload>(addApproversV2Actions);
